<header class="sticky top-0 z-50 border-b border-border-subtle bg-bg-base/80 shadow-md backdrop-blur-md">
  <div class="max-w-[85rem] mx-auto px-4 sm:px-6 lg:px-8">
    <div class="flex h-20 items-center justify-between gap-3">
      <!-- Logo -->
      <a class="flex items-center gap-3" routerLink="/" aria-label="HomiGo home">
        <img src="logo.png" alt="HomiGo" class="block h-10 w-auto md:h-16" />
      </a>

      <!-- Desktop nav -->
      <nav class="hidden items-center gap-1 rounded-2xl border border-border bg-surface/65 backdrop-blur-md p-1 lg:flex"
        aria-label="Primary">
        <a routerLink="/home" routerLinkActive="active"
          class="rounded-xl px-4 py-2 text-sm font-medium text-text-secondary transition-all hover:bg-surface-hover hover:text-primary">{{
          'navbar.links.home' | translate }}</a>
        <a routerLink="/all-properties" routerLinkActive="active"
          class="rounded-xl px-4 py-2 text-sm font-medium text-text-secondary transition-all hover:bg-surface-hover hover:text-primary">{{
          'navbar.links.allProperties' | translate }}</a>
        <!-- <a
          routerLink="/rent"
          routerLinkActive="active"
          class="rounded-xl px-4 py-2 text-sm font-medium text-text-secondary transition-all hover:bg-surface-hover hover:text-primary"
          >{{ 'navbar.links.rent' | translate }}</a
        >
        <a
          routerLink="/buy"
          routerLinkActive="active"
          class="rounded-xl px-4 py-2 text-sm font-medium text-text-secondary transition-all hover:bg-surface-hover hover:text-primary"
          >{{ 'navbar.links.buy' | translate }}</a
        > -->
        <a routerLink="/projects" routerLinkActive="active"
          class="rounded-xl px-4 py-2 text-sm font-medium text-text-secondary transition-all hover:bg-surface-hover hover:text-primary">{{
          'navbar.links.projects' | translate }}</a>
        <a routerLink="/experts" routerLinkActive="active"
          class="rounded-xl px-4 py-2 text-sm font-medium text-text-secondary transition-all hover:bg-surface-hover hover:text-primary">{{
          'navbar.links.experts' | translate }}</a>
        <a routerLink="/about" routerLinkActive="active"
          class="rounded-xl px-4 py-2 text-sm font-medium text-text-secondary transition-all hover:bg-surface-hover hover:text-primary">{{
          'navbar.links.about' | translate }}</a>
        <!-- <a routerLink="/plans" routerLinkActive="active"
          class="rounded-xl px-4 py-2 text-sm font-medium text-text-secondary transition-all hover:bg-surface-hover hover:text-primary">{{
          'navbar.links.plans' | translate }}</a> -->
      </nav>

      <!-- Actions (desktop) -->
      <div class="hidden items-center gap-2 lg:flex">
        <!-- Currency Dropdown -->
        <div class="relative">
          <!-- <button (click)="toggleCurrencyDropdown()"
            class="inline-flex items-center gap-2 rounded-xl border border-border-strong bg-surface px-3.5 py-2.5 text-sm font-medium text-text-secondary transition-all hover:border-primary/30 hover:text-primary"
            title="Change Currency" aria-label="Change currency">
            <span class="fi fi-{{ currentCurrencyInfo?.flag }} text-lg"></span>
            <span class="text-sm font-semibold">{{ currentCurrencyInfo?.code }}</span>
            <i class="fa-solid fa-chevron-down text-xs transition-transform"
              [class.rotate-180]="showCurrencyDropdown"></i>
          </button> -->

          <!-- Currency Dropdown Menu -->
          <!-- @if (showCurrencyDropdown) {
          <div
            class="absolute right-0 top-full mt-2 w-56 rounded-xl border border-border-strong bg-surface shadow-lg overflow-hidden z-50">
            @for (currency of currencies; track currency.code) {
            <button (click)="selectCurrency(currency.code)"
              class="flex w-full items-center gap-3 px-4 py-3 text-sm text-text-secondary transition-colors hover:bg-surface-hover"
              [class.bg-primary/5]="currentCurrency === currency.code">
              <span class="fi fi-{{ currency.flag }} text-xl"></span>
              <div class="flex-1 text-left">
                <div class="font-semibold">{{ currency.code }}</div>
                <div class="text-xs text-text-muted">{{ currency.name }}</div>
              </div>
              @if (currentCurrency === currency.code) {
              <i class="fa-solid fa-check text-primary"></i>
              }
            </button>
            }
          </div>
          } -->
        </div>

        <!-- Language Dropdown -->
        <div class="relative">
          <button (click)="toggleLanguageDropdown()"
            class="inline-flex items-center gap-2 rounded-xl border border-border-strong bg-surface px-3.5 py-2.5 text-sm font-medium text-text-secondary transition-all hover:border-primary/30 hover:text-primary"
            [title]="currentLanguage === 'ar' ? 'Switch to English' : 'التبديل للعربية'" aria-label="Switch language">
            <i class="fa-solid fa-language text-base"></i>
            <span class="text-sm">{{ languageLabel }}</span>
            <i class="fa-solid fa-chevron-down text-xs transition-transform"
              [class.rotate-180]="showLanguageDropdown"></i>
          </button>

          <!-- Language Dropdown Menu -->
          @if (showLanguageDropdown) {
          <div
            class="absolute right-0 top-full mt-2 w-48 rounded-xl border border-border-strong bg-surface shadow-lg overflow-hidden z-50">
            <button (click)="selectLanguage('ar')"
              class="flex w-full items-center gap-3 px-4 py-3 text-sm text-text-secondary transition-colors hover:bg-surface-hover"
              [class.bg-primary/5]="currentLanguage === 'ar'">
              <span class="font-medium">العربية</span>
              @if (currentLanguage === 'ar') {
              <i class="fa-solid fa-check text-primary ml-auto"></i>
              }
            </button>
            <button (click)="selectLanguage('en')"
              class="flex w-full items-center gap-3 px-4 py-3 text-sm text-text-secondary transition-colors hover:bg-surface-hover"
              [class.bg-primary/5]="currentLanguage === 'en'">
              <span class="font-medium">English</span>
              @if (currentLanguage === 'en') {
              <i class="fa-solid fa-check text-primary ml-auto"></i>
              }
            </button>
          </div>
          }
        </div>

        <!-- Authenticated User Actions -->
        <div *ngIf="isAuthenticated" class="flex items-center gap-2">
          <button (click)="goToFavorites()"
            class="inline-flex h-10 w-10 items-center justify-center rounded-xl border border-border-strong text-text-secondary transition-all hover:border-primary/30 hover:text-primary"
            title="المفضلة" aria-label="Favorites">
            <i class="fa-solid fa-heart h-4 w-4" aria-hidden="true"></i>
          </button>

          <!-- Notifications dropdown -->
          <div class="relative">
            <button (click)="toggleNotificationsDropdown($event)"
              class="relative inline-flex h-10 w-10 items-center justify-center rounded-xl border border-border-strong text-text-secondary transition-all hover:border-primary/30 hover:text-primary"
              [class.border-primary/40]="showNotificationsDropdown" [class.text-primary]="showNotificationsDropdown"
              [title]="'navbar.actions.notifications' | translate" aria-label="Notifications">
              <i class="fa-solid fa-bell text-sm" aria-hidden="true"></i>
              @if (unreadCount > 0) {
              <span
                class="absolute -top-1 -end-1 flex h-4 min-w-4 items-center justify-center rounded-full bg-primary px-1 text-[9px] font-black text-text-primary leading-none">
                {{ unreadCount > 9 ? '9+' : unreadCount }}
              </span>
              }
            </button>

            @if (showNotificationsDropdown) {
            <div
              class="absolute end-0 top-full mt-2 w-80 rounded-2xl border border-border-subtle bg-surface shadow-xl shadow-black/50 z-50 overflow-hidden"
              (click)="$event.stopPropagation()">

              <!-- Header -->
              <div class="flex items-center justify-between px-4 py-3 border-b border-border-subtle">
                <div class="flex items-center gap-2">
                  <h3 class="text-sm font-bold text-text-primary">{{ 'navbar.actions.notifications' | translate }}</h3>
                  @if (unreadCount > 0) {
                  <span
                    class="inline-flex items-center justify-center h-5 min-w-5 rounded-full bg-primary/10 px-1.5 text-[10px] font-black text-primary">
                    {{ unreadCount }}
                  </span>
                  }
                </div>
                <div class="flex items-center gap-2">
                  <button (click)="loadNotifications()"
                    class="text-[11px] font-semibold text-text-muted hover:text-text-secondary transition-colors p-1 rounded-lg hover:bg-surface-hover"
                    title="Refresh">
                    <i class="fas fa-rotate text-xs" [class.animate-spin]="notificationsLoading"></i>
                  </button>
                  @if (unreadCount > 0) {
                  <button (click)="markAllAsRead()" [disabled]="markingAll"
                    class="text-[11px] font-semibold text-primary hover:text-primary-deep transition-colors disabled:opacity-50">
                    @if (markingAll) { <i class="fas fa-circle-notch fa-spin text-[10px] me-1"></i> }
                    Mark all read
                  </button>
                  }
                </div>
              </div>

              <!-- List -->
              <div class="max-h-80 overflow-y-auto divide-y divide-gray-50">

                @if (notificationsLoading) {
                <div class="flex items-center justify-center gap-2 py-8 text-xs text-text-muted">
                  <i class="fas fa-circle-notch fa-spin text-primary"></i>
                  <span>Loading...</span>
                </div>
                }

                @if (!notificationsLoading && notifications.length === 0) {
                <div class="flex flex-col items-center justify-center py-10 text-center">
                  <div class="w-10 h-10 rounded-full bg-surface-elevated flex items-center justify-center mb-2">
                    <i class="fas fa-bell-slash text-text-muted text-sm"></i>
                  </div>
                  <p class="text-xs font-semibold text-text-muted">No notifications</p>
                  <p class="text-[10px] text-text-muted mt-0.5">You're all caught up!</p>
                </div>
                }

                @for (n of notifications; track n._id) {
                <button class="w-full flex items-start gap-3 px-4 py-3 text-start transition-colors hover:bg-surface-hover"
                  [class.bg-primary/10]="!n.isRead" (click)="openNotification(n, $event)">

                  <!-- Unread dot -->
                  <span class="mt-1.5 h-2 w-2 rounded-full shrink-0 transition-colors" [class.bg-primary]="!n.isRead"
                    [class.bg-transparent]="n.isRead"></span>

                  <div class="min-w-0 flex-1">
                    @if (n.title) {
                    <p class="text-xs font-bold text-text-primary truncate">{{ n.title }}</p>
                    }
                    <p class="text-[11px] leading-snug text-text-secondary line-clamp-2" [class.font-medium]="!n.isRead">
                      {{ n.message }}
                    </p>
                    <span class="mt-1 block text-[10px] text-text-muted font-medium">
                      {{ timeAgo(n.createdAt) }}
                    </span>
                  </div>
                </button>
                }
              </div>

              <!-- Footer -->
              <!-- <div class="border-t border-border-subtle px-4 py-2.5 bg-gray-50/50">
                <a [routerLink]="dashboardRoute" (click)="showNotificationsDropdown = false"
                  class="block text-center text-[11px] font-bold text-primary hover:text-primary-deep transition-colors">
                  View all notifications →
                </a>
              </div> -->

            </div>
            }
          </div>

          <a [routerLink]="dashboardRoute"
            class="inline-flex h-10 w-10 items-center justify-center rounded-xl border border-border-strong text-text-secondary transition-all hover:border-primary/30 hover:text-primary"
            title="الداشبورد" aria-label="Dashboard">
            <i class="fa-solid fa-user h-4 w-4" aria-hidden="true"></i>
          </a>
          <button (click)="logout()"
            class="inline-flex items-center gap-2 rounded-xl btn-primary border-none px-5 py-2.5 text-sm font-medium "
            [title]="'navbar.actions.logout' | translate" aria-label="Logout">
            <i class="fa-solid fa-sign-out-alt h-4 w-4" aria-hidden="true"></i>
            <span>{{ 'navbar.actions.logout' | translate }}</span>
          </button>
        </div>

        <!-- Guest Actions -->
        <div *ngIf="!isAuthenticated" class="flex items-center gap-2">
          <a routerLink="/auth/login"
            class="inline-flex items-center gap-2 rounded-xl border border-border-strong px-5 py-2.5 text-sm font-medium text-text-primary transition-all hover:bg-primary/20 hover:text-text-primary">
            <i class="fa-solid fa-user h-4 w-4" aria-hidden="true"></i>
            <span>{{ 'navbar.actions.signIn' | translate }}</span>
          </a>

          <button (click)="openRegisterPopup()"
            class="inline-flex items-center gap-2 rounded-xl btn-primary border-none px-5 py-2.5 text-sm font-medium ">
            <i class="fa-solid fa-user-plus h-4 w-4" aria-hidden="true"></i>
            <span>{{ 'navbar.actions.signUp' | translate }}</span>
          </button>
        </div>
      </div>
      <!-- Currency Dropdown Mobile -->
      <!-- <div class="relative lg:hidden">
        <button (click)="toggleCurrencyDropdown()"
          class="inline-flex w-full items-center gap-2 rounded-xl border border-border-strong px-4 py-2.5 text-sm font-medium text-text-secondary transition-all hover:border-primary/30 hover:text-primary"
          title="Change Currency">
          <span class="fi fi-{{ currentCurrencyInfo?.flag }} text-lg"></span>
          <span class="font-semibold">{{ currentCurrencyInfo?.code }}</span>
          <i class="fa-solid fa-chevron-down text-xs ml-auto transition-transform"
            [class.rotate-180]="showCurrencyDropdown"></i>
        </button>

        @if (showCurrencyDropdown) {
        <div class="mt-2 rounded-xl border border-border-strong bg-surface overflow-hidden absolute top-10">
          @for (currency of currencies; track currency.code) {
          <button (click)="selectCurrency(currency.code)"
            class="flex w-full items-center gap-3 px-4 py-3 text-sm text-text-secondary transition-colors hover:bg-surface-hover"
            [class.bg-primary/5]="currentCurrency === currency.code">
            <span class="fi fi-{{ currency.flag }} text-xl"></span>
            <div class="flex-1 text-left">
              <div class="font-semibold">{{ currency.code }}</div>
              <div class="text-xs text-text-muted">{{ currency.name }}</div>
            </div>
            @if (currentCurrency === currency.code) {
            <i class="fa-solid fa-check text-primary"></i>
            }
          </button>
          }
        </div>
        }
      </div> -->
      <!-- Mobile: burger -->
      <div class="lg:hidden">
        <button (click)="toggleMenu()" aria-controls="mobileMenu" [attr.aria-expanded]="ariaExpanded"
          class="inline-flex h-11 w-11 items-center justify-center rounded-xl border border-border-strong text-text-secondary transition-all hover:border-primary/30 hover:text-primary focus:outline-none focus:ring-2 focus:ring-primary/30">
          <span class="sr-only">Open menu</span>
          <i [class]="showMobileMenu ? 'fa-solid fa-xmark text-lg' : 'fa-solid fa-bars text-lg'" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  </div>

  <!-- Mobile menu -->
  <div id="mobileMenu" class="lg:hidden" *ngIf="showMobileMenu" role="dialog" aria-modal="true">
    <div class="space-y-4 border-t border-border-subtle bg-surface px-4 pb-6 pt-4 shadow-md">
      <nav class="grid grid-cols-1 gap-2" aria-label="Mobile Primary">
        <a routerLink="/home" routerLinkActive="active" (click)="closeMenu()"
          class="rounded-xl px-3 py-2.5 text-sm font-medium text-text-secondary transition-all hover:bg-surface-hover hover:text-primary">{{
          'navbar.links.home' | translate }}</a>
        <a routerLink="/all-properties" routerLinkActive="active" (click)="closeMenu()"
          class="rounded-xl px-3 py-2.5 text-sm font-medium text-text-secondary transition-all hover:bg-surface-hover hover:text-primary">{{
          'navbar.links.allProperties' | translate }}</a>
        <!-- <a
          routerLink="/rent"
          routerLinkActive="active"
          (click)="closeMenu()"
          class="rounded-xl px-3 py-2.5 text-sm font-medium text-text-secondary transition-all hover:bg-surface-hover hover:text-primary"
          >{{ 'navbar.links.rent' | translate }}</a
        >
        <a
          routerLink="/buy"
          routerLinkActive="active"
          (click)="closeMenu()"
          class="rounded-xl px-3 py-2.5 text-sm font-medium text-text-secondary transition-all hover:bg-surface-hover hover:text-primary"
          >{{ 'navbar.links.buy' | translate }}</a
        > -->
        <a routerLink="/projects" routerLinkActive="active" (click)="closeMenu()"
          class="rounded-xl px-3 py-2.5 text-sm font-medium text-text-secondary transition-all hover:bg-surface-hover hover:text-primary">{{
          'navbar.links.projects' | translate }}</a>
        <a routerLink="/experts" routerLinkActive="active" (click)="closeMenu()"
          class="rounded-xl px-3 py-2.5 text-sm font-medium text-text-secondary transition-all hover:bg-surface-hover hover:text-primary">{{
          'navbar.links.experts' | translate }}</a>
        <a routerLink="/about" routerLinkActive="active" (click)="closeMenu()"
          class="rounded-xl px-3 py-2.5 text-sm font-medium text-text-secondary transition-all hover:bg-surface-hover hover:text-primary">{{
          'navbar.links.about' | translate }}</a>
        <!-- <a routerLink="/plans" routerLinkActive="active" (click)="closeMenu()"
          class="rounded-xl px-3 py-2.5 text-sm font-medium text-text-secondary transition-all hover:bg-surface-hover hover:text-primary">{{
          'navbar.links.plans' | translate }}</a> -->
      </nav>

      <div class="h-px bg-surface-elevated"></div>

      <div class="flex flex-col gap-2 pt-1">
        <!-- Language Button Mobile -->
        <button (click)="toggleLanguage()"
          class="inline-flex items-center gap-2 rounded-xl border border-border-strong px-4 py-2.5 text-sm font-medium text-text-secondary transition-all hover:border-primary/30 hover:text-primary"
          [title]="currentLanguage === 'ar' ? 'Switch to English' : 'التبديل للعربية'">
          <i class="fa-solid fa-language text-base"></i>
          <span>{{ languageLabel }}</span>
        </button>

        <div *ngIf="!isAuthenticated" class="grid grid-cols-2 gap-2">
          <a routerLink="/auth/login" (click)="closeMenu()"
            class="inline-flex items-center justify-center rounded-xl border border-border-strong px-4 py-2.5 text-sm font-medium text-text-primary transition-all hover:bg-primary/20 hover:text-text-primary">Sign
            In</a>
          <button (click)="openRegisterPopup(); closeMenu()"
            class="inline-flex items-center justify-center rounded-xl btn-primary border-none px-4 py-2.5 text-sm font-medium ">
            {{ 'navbar.actions.signUp' | translate }}
          </button>
        </div>

        <div *ngIf="isAuthenticated" class="grid grid-cols-2 gap-2">
          <button (click)="goToFavorites(); closeMenu()"
            class="inline-flex items-center justify-center gap-2 rounded-xl border border-border-strong px-4 py-2.5 text-sm font-medium text-text-secondary">
            <i class="fa-solid fa-heart"></i>
            <span>{{ 'navbar.actions.favorites' | translate }}</span>
          </button>
          <a [routerLink]="dashboardRoute" (click)="closeMenu()"
            class="inline-flex items-center justify-center gap-2 rounded-xl border border-border-strong px-4 py-2.5 text-sm font-medium text-text-secondary">
            <i class="fa-solid fa-user"></i>
            <span>{{ 'navbar.actions.dashboard' | translate }}</span>
          </a>
          <button (click)="logout(); closeMenu()"
            class="col-span-2 inline-flex items-center justify-center gap-2 rounded-xl btn-primary border-none px-4 py-2.5 text-sm font-medium ">
            <i class="fa-solid fa-sign-out-alt"></i>
            <span>{{ 'navbar.actions.logout' | translate }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</header>

<app-register-pop [isOpen]="showRegisterPopup" (close)="closeRegisterPopup()"></app-register-pop>

<!-- ══════════════ NOTIFICATION MODAL ══════════════ -->
@if (selectedNotification) {
<div class="fixed inset-0 z-[9999] flex items-center justify-center p-4" (click)="closeNotificationModal()">

  <!-- Backdrop -->
  <div class="absolute inset-0 bg-black/40 backdrop-blur-sm"></div>

  <!-- Modal panel -->
  <div class="relative w-full max-w-md rounded-3xl bg-surface shadow-2xl shadow-black/60 overflow-hidden"
    (click)="$event.stopPropagation()">

    <!-- Top accent bar -->
    <div class="h-1 w-full btn-primary border-none"></div>

    <!-- Header -->
    <div class="flex items-start justify-between gap-4 px-6 pt-5 pb-4">
      <div class="flex items-center gap-3">
        <!-- Icon -->
        <div class="w-10 h-10 rounded-2xl bg-primary/10 flex items-center justify-center shrink-0">
          <i class="fas fa-bell text-primary text-sm"></i>
        </div>
        <div>
          <p class="text-[10px] font-bold uppercase tracking-widest text-primary">Notification</p>
          <div class="flex items-center gap-2 mt-0.5">
            @if (selectedNotification.isRead) {
            <span class="inline-flex items-center gap-1 text-[10px] font-bold text-success">
              <i class="fas fa-check-circle text-[9px]"></i> Read
            </span>
            } @else {
            <span class="inline-flex items-center gap-1 text-[10px] font-bold text-primary">
              <span class="w-1.5 h-1.5 rounded-full bg-primary"></span> Unread
            </span>
            }
          </div>
        </div>
      </div>

      <!-- Close -->
      <button (click)="closeNotificationModal()"
        class="w-8 h-8 flex items-center justify-center rounded-xl text-text-muted hover:text-text-secondary hover:bg-surface-elevated transition-all shrink-0">
        <i class="fas fa-xmark text-sm"></i>
      </button>
    </div>

    <!-- Body -->
    <div class="px-6 pb-6">

      @if (notificationDetailLoading) {
      <div class="flex items-center justify-center gap-2 py-8 text-sm text-text-muted">
        <i class="fas fa-circle-notch fa-spin text-primary"></i>
        <span>Loading...</span>
      </div>
      } @else {

      <!-- Title -->
      @if (selectedNotification.title) {
      <h3 class="text-base font-bold text-text-primary mb-2 leading-snug">
        {{ selectedNotification.title }}
      </h3>
      }

      <!-- Message -->
      <p class="text-sm text-text-secondary leading-relaxed">
        {{ selectedNotification.message }}
      </p>

      <!-- Meta: type + time -->
      <div class="mt-4 flex items-center justify-between gap-3 pt-4 border-t border-border-subtle">
        @if (selectedNotification.type) {
        <span
          class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-lg bg-surface-elevated text-text-secondary text-[10px] font-bold uppercase tracking-wider">
          <i class="fas fa-tag text-[9px]"></i>
          {{ selectedNotification.type }}
        </span>
        } @else {
        <span></span>
        }
        <span class="text-[11px] text-text-muted font-medium">
          <i class="fas fa-clock text-[10px] me-1"></i>
          {{ timeAgo(selectedNotification.createdAt) }}
        </span>
      </div>

      <!-- Link -->
      @if (selectedNotification.link) {
      <a [href]="selectedNotification.link" target="_blank"
        class="mt-3 inline-flex items-center gap-2 text-xs font-semibold text-primary hover:text-primary-deep transition-colors">
        <i class="fas fa-arrow-up-right-from-square text-[10px]"></i>
        View details
      </a>
      }

      }
    </div>

  </div>
</div>
}